import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Clear the token and user data from localStorage and sessionStorage
    localStorage.removeItem("authToken");
    localStorage.removeItem("authData");
    sessionStorage.removeItem("authToken");
    sessionStorage.removeItem("authData");

    // Remove Axios default Authorization header
    delete axios.defaults.headers.common["Authorization"];

    // Show a logout success message
    toast.success("Logged out successfully!");

    // Redirect to the login page
    navigate("/");
  }, [navigate]);

  return null; // No UI is needed for logout functionality
};

export default Logout;
